import { todayDateOnlyIso } from "./currentLeaveHelpers";

export const ANNUAL_LEAVE_NOTICE_DAYS = 3;

export const ANNUAL_LEAVE_NOTICE_MESSAGE =
  "يجب تقديم الإجازة الاعتيادية قبل تاريخ بدايتها بـ 3 أيام على الأقل.";

function addDaysToIso(iso, days) {
  const [year, month, day] = iso.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function earliestAnnualLeaveStartDate(now = new Date()) {
  return addDaysToIso(todayDateOnlyIso(now), ANNUAL_LEAVE_NOTICE_DAYS);
}

export function isAnnualLeaveNoticeSatisfied(startDateIso, now = new Date()) {
  if (!startDateIso) return false;
  return startDateIso >= earliestAnnualLeaveStartDate(now);
}
